export enum Actions {
    COPY = 'COPY',
    SHARE = 'SHARE'
}
